import { React, AppBar } from '../../utils/globalImports';

const Header: React.FC = () => {
  return (
    <AppBar position="fixed">
    </AppBar>
  );
};

export default Header;